class PerformanceMonitor {
  constructor() {
    this.fps = 60;
    this.lastTime = performance.now();
    this.frames = 0;
    this.fpsUpdateInterval = 1000; // Update FPS every second
    this.lastFpsUpdate = this.lastTime;
    this.lowPerformanceThreshold = 30;
  }

  begin() {
    this.startTime = performance.now();
  }

  end() {
    this.frames++;
    const currentTime = performance.now();

    if (currentTime >= this.lastFpsUpdate + this.fpsUpdateInterval) {
      this.fps = Math.round((this.frames * 1000) / (currentTime - this.lastFpsUpdate));
      this.frames = 0;
      this.lastFpsUpdate = currentTime;

      // Adaptive quality - dispatch event if performance is low
      if (this.fps < this.lowPerformanceThreshold) {
        console.warn(`Low FPS detected: ${this.fps}`);
        this.onLowPerformance();
      }
    }
  }

  onLowPerformance() {
    // Dispatch custom event for app to handle
    window.dispatchEvent(
      new CustomEvent('low-performance', {
        detail: { fps: this.fps }
      })
    );
  }

  getFPS() {
    return this.fps;
  }
}

export default PerformanceMonitor;
